import { render, staticRenderFns } from "./bo-new-shipping-address.vue?vue&type=template&id=7c792311"
import script from "./bo-new-shipping-address.vue?vue&type=script&lang=js"
export * from "./bo-new-shipping-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports